import React, { useEffect, useState } from 'react';
import Component from './Component';
import { useFile, useSource } from '../../hooks';

export const ImageCompiler = ({
  className = '',
  file,
  scale,
  source,
  ...props
}) => {
  const { url: fallback = file } = useFile(file);
  className = scale ? `${className} ${scale}` : className;
  return (
    <Image
      {...props}
      className={className}
      src={source || fallback}
      fallback={fallback}
    />
  );
};
export const Image = ({
  className = '',
  itemDataSrc,
  fallback: fallbackProp,
  src: srcProp,
  tag: Tag = 'img',
  ...props
}) => {
  const { itemData: data } = props;
  if (itemDataSrc?.[0] === '@') {
    srcProp = itemDataSrc;
  }
  let { value: fallback = fallbackProp } = useSource(fallbackProp, { data });
  const { value } = useSource(srcProp, { data });
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [value]);

  fallback =
    fallback &&
    encodeURI(
      fallback.replace(/\(@field\.([^)]*)\)/g, (str, field) => data[field])
    );
  let src =
    (itemDataSrc?.match?.(/^(@|data:image\/|(blob:)?http|\/static\/)/) &&
      itemDataSrc) ||
    (value?.match?.(/^(@|data:image\/|(blob:)?http|\/static\/)/) && value) ||
    (srcProp?.match?.(/^(data:image\/|(blob:)?http|\/static\/)/) && srcProp) ||
    fallback;

  if (hasError) {
    src = fallback;
  }

  if (src?.match(/^@/)) {
    return <Image {...props} className={className} src={src} />;
  }

  return (
    <Component
      {...props}
      src={src}
      className={`image ${className}`.trim()}
      component={Tag}
      onError={(e) => {
        if (fallback && e.currentTarget.src !== fallback) {
          setHasError(true);
        }
      }}
    />
  );
};

Image.displayName = 'Image';
ImageCompiler.displayName = 'Image';
export default ImageCompiler;
